import type React from "react"

const EDITOR_SELECTOR = "textarea,input,[contenteditable='true']"

const INTERACTIVE_SELECTOR = [
  EDITOR_SELECTOR,
  "button",
  "a",
  "select",
  "[role='button']",
  "[role='menuitem']",
].join(",")

/**
 * Focuses the last text editor nested inside a padded wrapper, so a click on
 * the wrapper's own padding lands in the value editor instead of nothing.
 * Clicks on nested interactive elements keep their own behavior.
 */
export function focusNestedEditor(event: React.MouseEvent<HTMLElement>): void {
  const target = event.target as HTMLElement

  if (target.closest(INTERACTIVE_SELECTOR)) {
    return
  }

  const editors =
    event.currentTarget.querySelectorAll<HTMLElement>(EDITOR_SELECTOR)

  editors[editors.length - 1]?.focus()
}
